// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3W2SU","left":"StickyBox_left__1inwk","right":"StickyBox_right__3GEsl"};